module.exports = __webpack_public_path__ + "static/img/leumi-small.f6474eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/leumi-small.svg
// module id = ZYEj
// module chunks = 6